import { Box, Chip, Grid, Typography } from "@material-ui/core"
import ButtonRounded from "components/Common/ButtonRounded"
import SeatMemberListItem from "components/Common/SeatMemberListItem"
import { useFormikContext } from "formik"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import transformCaseAndSpaces from "utils/transformCaseAndSpaces"

import useStyles from "./styles"

const Embedded = ({ areasOfInterest, areasOfExpertise, areasOfExperience }) => {
  const { values } = useFormikContext()
  const classes = useStyles()
  const [hideMembers, setHideMembers] = useState(false)

  const hideMembersFunc = () => {
    setHideMembers((oldState) => !oldState)
  }
  const findOpenPositions = values?.positions.filter(
    (x) => x.member.currently_vacant
  )
  const findfilledPositions = values?.positions.filter(
    (x) => !x.member.currently_vacant
  )
  const openPositions = findOpenPositions?.length
  const filledPositions = findfilledPositions?.length
  const totalPositions = filledPositions + openPositions

  const displayTerm = () => {
    if (values?.term?.toLowerCase() === "other") {
      return "Term Varies By Role/Seat"
    } else if (values?.term?.toLowerCase() === "no term limit") {
      return "No Term Limit"
    } else {
      return `${transformCaseAndSpaces(values?.term)} Term`
    }
  }

  return (
    <Box className={classes.container}>
      <>
        <Box
          className={classes.firstSubContainer}
          display="flex"
          justifyContent="space-between"
        >
          <Typography variant="h6">{values?.name}</Typography>
          <Typography>{values?.city}</Typography>
        </Box>
        <Box className={classes.secondSubContainer} display="flex">
          <Typography
            className={classes.secondSubContainerData}
            variant="body1"
            color="secondary"
          >
            <span style={{ fontWeight: "bold" }}>{openPositions}</span> of{" "}
            <span style={{ fontWeight: "bold" }}>{totalPositions}</span>{" "}
            Available
            <span style={{ margin: "0 5px" }}> • </span>
            <span>{displayTerm()}</span>
          </Typography>
        </Box>

        <Box className={classes.summaryContainer}>
          <Typography style={{ whiteSpace: "pre-wrap" }}>
            {values.summary}
          </Typography>
        </Box>
        <Box className={classes.seatMembersContainer}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography className={classes.membersTitle}>
              CURRENT SEAT MEMBERS
            </Typography>
            <ButtonRounded onClick={hideMembersFunc}>
              {!hideMembers ? (
                <Typography className={classes.hideButtonText} variant="body2">
                  HIDE MEMBERS
                </Typography>
              ) : (
                <Typography className={classes.hideButtonText} variant="body2">
                  SHOW MEMBERS
                </Typography>
              )}
            </ButtonRounded>
          </Box>
          {!hideMembers ? (
            <Grid container spacing={3}>
              {values?.positions?.map((p, i) => {
                const passedMember = {
                  ...p?.member,
                  id: p?.id,
                  position: p?.position,
                }
                return (
                  <Grid item key={i} xs={4}>
                    <SeatMemberListItem
                      member={passedMember}
                      vacant={passedMember?.first_name ? false : true}
                      boardTerm={values?.term}
                    />
                  </Grid>
                )
              })}
            </Grid>
          ) : null}
        </Box>
        <Box
          width="100%"
          display="flex"
          flexWrap="wrap"
          alignItems="space-between"
          marginTop="12px"
        >
          {areasOfInterest?.map?.((x, i) => (
            <Chip
              key={i}
              label={x?.name}
              color="primary"
              classes={{ root: classes.chipRoot, label: classes.chipLabel }}
            />
          ))}
        </Box>
      </>
    </Box>
  )
}

Embedded.propTypes = {
  tabValue: PropTypes.number,
  areasOfInterest: PropTypes.array,
  areasOfExpertise: PropTypes.array,
  areasOfExperience: PropTypes.array,
}

export default Embedded
